import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAccessToken } from "../../utils/authStorage";
import UserSessionManager from "../../utils/UserSessionManager";


export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const token = getAccessToken();

  if (!token) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  if (UserSessionManager.requiresPasswordChange()) {
    return <Navigate to="/changepassword" replace state={{ forced: true }} />;
  }

  return children;
}
